window.mapview = window.mapview || {};

mapview.cacheSelectors = function() {
  mapview.cache = {
    oms: null,
    markerIcon: {
      url: baseUrl + 'assets/images/marker.svg',
      anchor: new google.maps.Point(15, 15),
      scaledSize: new google.maps.Size(30, 30)
    },
    infoboxOptions: {
      disableAutoPan: false,
      maxWidth: 160,
      pixelOffset: new google.maps.Size(-80, -210),
      zIndex: null,
      boxStyle: {
        padding: '0px 0px 0px 0px',
        width: '160px',
        height: '170px'
      },
      closeBoxURL : '',
      infoBoxClearance: new google.maps.Size(1, 1),
      isHidden: false,
      pane: 'floatPane',
      enableEventPropagation: false
    }
  };
};

mapview.init = function() {
  mapview.cacheSelectors();

  var markers = window.markers;
  var markerList = [];
  var $overviewMap = $('#overview-map');

  if ($overviewMap.length) {
    var bounds = new google.maps.LatLngBounds(),
      zoom = 9,
      map = new google.maps.Map(document.getElementById('overview-map-holder'), {
        zoom: zoom,
        mapTypeControl: false,
        center: new google.maps.LatLng(51.3179193,4.9799453),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: googleMapsStyles,
      }),
      markers = window.markers;

    mapview.cache.oms = new OverlappingMarkerSpiderfier(map, {
      markersWontMove: true,
      markersWontHide: false,
      basicFormatEvents: true
    });

    // $overviewMap.waypoint(function(direction) {
    //   console.log(direction);
    //   if (direction == 'down') {
    //     $overviewMap.addClass('is-fixed');
    //   }
    // }, { offset: 125 });

    $('#overview-header').waypoint(function(direction) {
      if (direction == 'down') {
        $overviewMap.addClass('is-fixed');
      } else {
        $overviewMap.removeClass('is-fixed');
      }
    },{ offset: 0 });

    $('#properties-overview').waypoint(function(direction) {
      if (direction == 'down') {
        $overviewMap.addClass('is-bottom');
      } else {
        $overviewMap.removeClass('is-bottom');
      }
    }, { offset: 'bottom-in-view' });


    if (markers != undefined) {

      // no markers
      if (markers.length == 0) {
        $overviewMap.hide();
      }

      for (var i = 0, j = markers.length; i < j; i++){
        var markerData = markers[i];
        var currMarker = mapview.addMarkerWithInfobox(markerData, map, bounds, null, '')
        markerList.push(currMarker);
        mapview.cache.oms.addMarker(currMarker);
      };

      map.fitBounds(bounds);

      var options = {
        imagePath: baseUrl + 'assets/images/m',
        zoomOnClick: true
      };

      var markerCluster = new MarkerClusterer(map, markerList, options);
      var styles = markerCluster.getStyles();

      $.each(styles, function (index, value) {
        value.textColor = 'white';
        value.textSize = 14;
      });

      markerCluster.setStyles(styles);
      var minClusterZoom = 18;
      markerCluster.setMaxZoom(minClusterZoom);

      google.maps.event.addDomListener(window, 'resize', function() {
        map.fitBounds(bounds);
      });

      mapview.cache.oms.addListener('spiderfy', function(markers) {
        for(i=0;i<markers.length;i++) {
          markers[i].setIcon(mapview.cache.markerIcon);
        }
      });

      var markerIconSpider = {
        url: baseUrl + 'assets/images/marker-plus.png',
        anchor: new google.maps.Point(12, 12),
        scaledSize: new google.maps.Size(24, 24)
      };

      mapview.cache.oms.addListener('unspiderfy', function(markers) {
        //console.log('unspide');

        for(i=0;i<markers.length;i++) {
          markers[i].setIcon(markerIconSpider);
        }
      });

      google.maps.event.addListener(map, 'idle', function(){
        var stuff = mapview.cache.oms.markersNearAnyOtherMarker();

        for(i=0;i<stuff.length;i++) {
          stuff[i].setIcon(markerIconSpider);
        }
      });

    }
  }

};


mapview.addMarkerWithInfobox = function (markerData, map, bounds, description, infoboxClass) {

  var immoInfobox = true,
    markerAction = 'mouseover',
    icon = mapview.cache.markerIcon;

  if (markerData.hours) {
    immoInfobox = false;
    markerAction = 'click';

    icon = {
      url: base_url + 'assets/images/marker.png',
      anchor: new google.maps.Point(45, 61),
      scaledSize: new google.maps.Size(110, 110)
    };
  }

 /* if(markerData.search_match === true){
    icon.url = base_url + 'assets/images/marker.svg';
  }else if(markerData.search_match === false){
    icon.url = base_url + 'assets/images/marker.svg';
  }*/

  if(infoboxClass == 'infoBox--light') {
    icon.url = base_url + 'assets/images/marker.svg';
  }

  var marker = new google.maps.Marker({
    position: new google.maps.LatLng(markerData.lat, markerData.lng),
    icon: icon,
    map: map
  });


  if (markerData.url) {
/*
    google.maps.event.addListener(marker, 'click', function(marker, i) {
      window.location = markerData.url;
    });
*/

    google.maps.event.addListener(marker, 'click', function (marker, i) {


      var latLng = new google.maps.LatLng(markerData.lat, markerData.lng);
      map.panTo(latLng);

     // map.setZoom(15);


    });

    google.maps.event.addListener(marker, 'spider_click', function (marker, i) {
      window.location.href = markerData.url;
    });

  }


  google.maps.event.addListener(marker, markerAction, function(marker, i) {

    var options = {
      disableAutoPan: mapview.cache.infoboxOptions.disableAutoPan,
      maxWidth: mapview.cache.infoboxOptions.maxWidth,
      pixelOffset: mapview.cache.infoboxOptions.pixelOffset,
      zIndex: mapview.cache.infoboxOptions.zIndex,
      boxStyle: mapview.cache.infoboxOptions.boxStyle,
      closeBoxURL: mapview.cache.infoboxOptions.closeBoxURL,
      infoBoxClearance: mapview.cache.infoboxOptions.infoBoxClearance,
      isHidden: mapview.cache.infoboxOptions.isHidden,
      pane: mapview.cache.infoboxOptions.pane,
      enableEventPropagation: mapview.cache.infoboxOptions.enableEventPropagation
    };

    if (mapview.cache.infobox){
      mapview.cache.infobox.close();
    }

    var boxText = document.createElement('div');
    boxText.style.cssText = 'padding: 0;';

    var template = '',
      templateClass;

    if (immoInfobox) {
      templateClass = 'infoBox ' + infoboxClass;
      template = '<div class="info-box-item">'
        + '<div class="info-box-img" style="background-image: url(' + markerData.img + ');"></div>'
        + '<div class="info-box-item"><p>'
        + '<span class="title">' + markerData.title + '</span><br/>'
        /*+ '<span class="subtitle">' + markerData.subtitle + '</span>'*/
        + '</p>';

     /* if (description) {
        template += '<div class="description">' + description + '</div>';
      }*/

      template += '</div>'
        + '</div>';

    }

    boxText.innerHTML = template;

    if(infoboxClass == 'infoBox--detail') {
      options.content = boxText;
      options.boxClass = templateClass;
      options.maxWidth = 240;
      options.pixelOffset = new google.maps.Size(-120, -305);
      options.boxStyle = {
        padding: '0px 0px 0px 0px',
        width: '240px',
        height: '280px'
      };

      var infobox = new InfoBox(options);
      infobox.open(map, this);

    } else {

      options.content = boxText;
      options.boxClass = templateClass;

      mapview.cache.infobox = new InfoBox(options);
      mapview.cache.infobox.open(map, this);
    }

    //map.panTo(ib.getPosition());

  });

  if (immoInfobox) {
    google.maps.event.addListener(marker, 'mouseout', function(marker, i) {
      if (mapview.cache.infobox){
        mapview.cache.infobox.close();
      }
    });
  }

  if (bounds && markerData.search_match !== false) {
    bounds.extend(marker.position);
  }

  if (mapview.cache.markersArray === undefined) {
    mapview.cache.markersArray = [];
  }

  mapview.cache.markersArray.push(marker);

  return marker;


};

$(mapview.init);
